import { injectable } from 'inversify';

@injectable()
export class LoadingStore {
    private busyCounter = 0;
    private elem = document.querySelector('#loading-screen') as HTMLElement | null;
    private headerElem = document.querySelector('#loading-header') as HTMLElement | null;
    private timeout: any;

    private showHideLoadingScreen = (isLoading: boolean) => {
        if (this.elem) {
            if (isLoading && this.elem.style.display) {
                (window as any).updateLoadMsg();
            }
            this.elem.style.display = isLoading ? '' : 'none';

            isLoading && window.scrollTo(0, 0);
            document.body.style.overflow = isLoading ? 'hidden' : '';
        }
        if (!isLoading && this.headerElem) {
            this.headerElem.style.visibility = 'hidden';
            this.headerElem = null;
        }
    };

    busy(isBusy: boolean) {
        if (isBusy) {
            this.busyCounter += 1;
        } else if (this.busyCounter > 0) {
            this.busyCounter -= 1;
        }
        this.next();
    }

    private next() {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            const isLoading = this.busyCounter > 0;
            this.showHideLoadingScreen(isLoading);
            this.timeout = undefined;
        }, 1);
    }
}
